import * as React from 'react';

const ReplyHappyIcon: React.FC<any> = (props: any) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1403_8566)">
      <path
        d="M18 33C9.7155 33 3 26.2845 3 18C3 9.7155 9.7155 3 18 3C26.2845 3 33 9.7155 33 18C33 26.2845 26.2845 33 18 33ZM18 30C21.1826 30 24.2348 28.7357 26.4853 26.4853C28.7357 24.2348 30 21.1826 30 18C30 14.8174 28.7357 11.7652 26.4853 9.51472C24.2348 7.26428 21.1826 6 18 6C14.8174 6 11.7652 7.26428 9.51472 9.51472C7.26428 11.7652 6 14.8174 6 18C6 21.1826 7.26428 24.2348 9.51472 26.4853C11.7652 28.7357 14.8174 30 18 30ZM10.5 19.5H13.5C13.5 20.6935 13.9741 21.8381 14.818 22.682C15.6619 23.5259 16.8065 24 18 24C19.1935 24 20.3381 23.5259 21.182 22.682C22.0259 21.8381 22.5 20.6935 22.5 19.5H25.5C25.5 21.4891 24.7098 23.3968 23.3033 24.8033C21.8968 26.2098 19.9891 27 18 27C16.0109 27 14.1032 26.2098 12.6967 24.8033C11.2902 23.3968 10.5 21.4891 10.5 19.5ZM12 16.5C11.4033 16.5 10.831 16.2629 10.409 15.841C9.98705 15.419 9.75 14.8467 9.75 14.25C9.75 13.6533 9.98705 13.081 10.409 12.659C10.831 12.2371 11.4033 12 12 12C12.5967 12 13.169 12.2371 13.591 12.659C14.0129 13.081 14.25 13.6533 14.25 14.25C14.25 14.8467 14.0129 15.419 13.591 15.841C13.169 16.2629 12.5967 16.5 12 16.5ZM24 16.5C23.4033 16.5 22.831 16.2629 22.409 15.841C21.9871 15.419 21.75 14.8467 21.75 14.25C21.75 13.6533 21.9871 13.081 22.409 12.659C22.831 12.2371 23.4033 12 24 12C24.5967 12 25.169 12.2371 25.591 12.659C26.0129 13.081 26.25 13.6533 26.25 14.25C26.25 14.8467 26.0129 15.419 25.591 15.841C25.169 16.2629 24.5967 16.5 24 16.5Z"
        fill={props.htmlcolor}
      />
    </g>
    <defs>
      <clipPath id="clip0_1403_8566">
        <rect width="36" height="36" fill={props.htmlcolor} />
      </clipPath>
    </defs>
  </svg>
);

export default ReplyHappyIcon;
